/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { v4 as uuid } from "uuid";
import Select from 'react-select';
import { XIcon } from "@heroicons/react/solid";
import { AddCircle as AddIcon } from '@mui/icons-material';
import * as math from "mathjs";

export default function InventoryWaste({ type, value, close }) {
  const curDate = new Date();
  const voucherItems = value?.transaction[0]?.items;
  const modifiedItemsData = voucherItems?.map((a, i) => {
    return {
      key: i,
      item_uuid: a.item_uuid || '',
      qty: Math.abs(a.qty),
      subaction: '0',
      remarks: a.remarks || '',
      unit_uuid: a.unit_uuid || '',
    }
  });
  const DEFAULT_VALUES = {
    voucher_date: type === 'edit' ? (new Date(+value.voucher_date)).getTime() : (new Date(Date.UTC(curDate?.getFullYear(), curDate?.getMonth(), curDate?.getDate(), 0, 0, 0))).getTime(),
    voucher_narration: type === 'edit' ? value.voucher_narration : "",
    voucher_remarks: type === 'edit' ? value.voucher_remarks : "",
    voucher_type: "WA",
    voucher_uuid: type === 'edit' ? value.voucher_uuid : "",
    created_at: type === 'edit' ? value.created_at : "",
    warehouse_uuid: type === 'edit' ? value.transaction[0]?.warehouse_uuid : "",
    items1: type === 'edit' ? modifiedItemsData : [{
      key: 0,
      item_uuid: '',
      qty: '',
      subaction: '0',
      remarks: '',
      unit_uuid: '',
    }],
  }
  const [data, setData] = useState(DEFAULT_VALUES);
  const [warehouses, setWarehouses] = useState([]);
  const [items, setItems] = useState([]);
  const [editValues, setEditValues] = useState(false);

  useEffect(() => {
    const getWarehouses = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/invWarehouse/ListWarehouse`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => { setWarehouses(data) })
        .catch(err => console.warn("post request failed", err));
    }
    const getItems = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/item/ListItem`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          if (data.length) {
            setItems(data)
          }
        })
        .catch(err => console.warn("post request failed", err));
    }
    getWarehouses();
    getItems();
    // console.log(data)
  }, [data]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        addNewRow();
        return false;
      }
    });
  }, []);

  const addNewRow = async () => {
    const arr = data.items1;
    arr.push({
      key: data.items1.length,
      item_uuid: '',
      qty: '',
      subaction: '0',
      remarks: '',
      unit_uuid: ''
    });
    setData({ ...data, items1: arr })
  }

  const EditItemsInDB = async () => {
    let updatedMainItems = [];
    const transactionItems = [];

    data.items1.forEach((a, i) => {
      if (a.qty && a.item_uuid) {

        const unitIngredients = items.find(i =>
          i.item_uuid === a.item_uuid
        )?.ingredients || [];

        // add/reduce item quantity based on main item or ingredients
        if (unitIngredients.length && a.subaction === '0') {
          unitIngredients.forEach(x => {
            const currentIngItemUnits = items.find(i =>
              i.item_uuid === x.item_uuid
            )?.units || [];

            const ingPrimaryUnit = currentIngItemUnits?.find(i =>
              i.unit_is_primary === 'Y'
            );

            const currentIngUnit = currentIngItemUnits?.find(i =>
              i.unit_uuid === x.unit_uuid
            );

            const denominatorIng = currentIngUnit?.unit_denominator;
            const numeratorIng = currentIngUnit?.unit_numerator;

            const mainItemSelectedUnit = items.find(i =>
              i.item_uuid === a.item_uuid
            )?.units?.find(u => u.unit_uuid === a.unit_uuid) || null;

            const mainItemdenominator = mainItemSelectedUnit?.unit_denominator;
            const mainItemNumerator = mainItemSelectedUnit?.unit_numerator;

            const getFractionQty = obj => `${obj.s * obj.n}/${obj.d}`;
            const calculateFractionQty = qty => {
              const obj = math.multiply(
                math.multiply(math.fraction(`${qty}`), math.fraction(`${numeratorIng}/${denominatorIng}`)),
                math.fraction(`${mainItemNumerator}/${mainItemdenominator}`)
              )
              const qtyFraction = getFractionQty(obj)
              return qtyFraction
            }

            if (type !== 'edit') {
              transactionItems.push({
                item_uuid: x.item_uuid,
                qty: (denominatorIng && numeratorIng) ? calculateFractionQty(a.qty * +x.qty) : getFractionQty(x.qty),
                unit_uuid: ingPrimaryUnit?.unit_uuid,
              });
            } else {
              transactionItems.push({
                item_uuid: x.item_uuid,
                qty: (denominatorIng && numeratorIng) ? calculateFractionQty(+a.qty - +DEFAULT_VALUES.items1[i]?.qty) : getFractionQty(x.qty),
                unit_uuid: ingPrimaryUnit?.unit_uuid,
              });
            }
          })

        } else {
          const primaryUnitId = items.find(i =>
            i.item_uuid === a.item_uuid
          )?.units?.find(i =>
            i.unit_is_primary === 'Y'
          )?.unit_uuid || null;

          const userSelectedUnit = items.find(i =>
            i.item_uuid === a.item_uuid
          )?.units?.find(i =>
            i.unit_uuid === a.unit_uuid
          );

          const denominator = userSelectedUnit?.unit_denominator;
          const numerator = userSelectedUnit?.unit_numerator;

          const getFractionQty = obj => `${obj.s * obj.n}/${obj.d}`;
          const calculateFractionQty = qty => {
            const obj = math.multiply(math.fraction(`${qty}`), math.fraction(`${numerator}/${denominator}`))
            const qtyFraction = getFractionQty(obj)
            return qtyFraction
          }

          if (type !== 'edit') {
            const obj = {
              item_uuid: a.item_uuid,
              qty: (denominator && numerator) ? calculateFractionQty(a.qty) : getFractionQty(math.fraction(a.qty)),
            };
            if (primaryUnitId) obj.unit_uuid = primaryUnitId;
            transactionItems.push(obj);
          } else {
            const obj = {
              item_uuid: a.item_uuid,
              qty: (denominator && numerator) ? calculateFractionQty(+a.qty - +DEFAULT_VALUES.items1[i]?.qty) : getFractionQty(math.fraction(+a.qty - +DEFAULT_VALUES.items1[i]?.qty)),
            };
            if (primaryUnitId) obj.unit_uuid = primaryUnitId;
            transactionItems.push(obj);
          }
        }
      }
    })
    if (transactionItems.length) {
      updatedMainItems = transactionItems.map(a => {
        const idata = items.find(b => b.item_uuid === a.item_uuid)
        const userSelectedUnit = idata?.units?.find(i => i.unit_uuid === a.unit_uuid);
        const denominator = userSelectedUnit?.unit_denominator || 1;
        const numerator = userSelectedUnit?.unit_numerator || 1;
        const getQty = obj => `${obj.s * obj.n}/${obj.d}`

        if (idata.inventory_level && idata.inventory_level.length > 0) {
          let w1Index = idata.inventory_level.findIndex(b => b.warehouse_uuid === data.warehouse_uuid)
          if (w1Index > -1) {

            const result = math.subtract(
              math.fraction(`${idata.inventory_level[w1Index].qty}`),
              math.multiply(math.fraction(`${a.qty}`), math.fraction(`${denominator}/${numerator}`))
            );

            idata.inventory_level[w1Index].qty = getQty(result);
            if (a.unit_uuid) idata.inventory_level[w1Index].unit_uuid = a.unit_uuid;
          } else {
            const obj = {
              warehouse_uuid: data.warehouse_uuid,
              qty: getQty(math.multiply(math.fraction(`${-a.qty}`), math.fraction(`${denominator}/${numerator}`)))
            }
            if (a.unit_uuid) obj.unit_uuid = a.unit_uuid;
            idata.inventory_level.push(obj);
          }
        } else {
          const obj = {
            warehouse_uuid: data.warehouse_uuid,
            qty: getQty(math.multiply(math.fraction(`${-a.qty}`), math.fraction(`${denominator}/${numerator}`)))
          }
          if (a.unit_uuid) obj.unit_uuid = a.unit_uuid;
          idata.inventory_level = [obj];
        }
        return idata;
      })
    }
    const json = updatedMainItems;
    const url = `https://api.myfooddo.com/item/putItem`;
    console.log(url, json)

    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(json),
    })
      .then(res => res.json())
      .then(data => {
        console.log('PutItem...', data)
      })
      .catch(err => console.warn("post request failed", err));
  }

  const CreateVoucherInDB = async () => {
    const arr1 = [];
    data.items1.forEach((a) => {
      if (a.qty && a.item_uuid) {
        const obj = {
          item_uuid: a.item_uuid,
          qty: `${-a.qty}`,
          remarks: a.remarks,
          unit_uuid: a.unit_uuid,
        }
        const unitIngredients = items.find(i =>
          i.item_uuid === a.item_uuid
        )?.ingredients?.map(i => {
          return { item_uuid: i.item_uuid, qty: i.qty, unit_uuid: i.unit_uuid }
        }) || [];

        if (unitIngredients.length && a.subaction === '0') {
          obj.unit_ingredients = unitIngredients;
        }
        arr1.push(obj);
      }
    })
    if (arr1.length) {
      const json = {
        created_at: Date.now(),
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        transaction: [
          {
            warehouse_uuid: data.warehouse_uuid,
            items: arr1
          }
        ],
        voucher_date: data.voucher_date,
        voucher_narration: data.voucher_narration,
        voucher_remarks: data.voucher_remarks,
        voucher_type: data.voucher_type,
        voucher_uuid: uuid(),
      }
      const url = `https://api.myfooddo.com/voucher/CreateVoucher`;
      // const url = `http://localhost:5000/voucher/CreateVoucher`;
      console.log(url, json);
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          console.log("CreateVoucher...", data);
        })
        .catch(err => console.warn("post request failed", err));
    }
  }

  const EditVoucherInDB = async () => {
    const arr1 = [];
    data.items1.forEach((a) => {
      if (a.qty && a.item_uuid) {
        const obj = {
          item_uuid: a.item_uuid,
          qty: `${-a.qty}`,
          remarks: a.remarks,
          unit_uuid: a.unit_uuid,
        }
        const unitIngredients = items.find(i =>
          i.item_uuid === a.item_uuid
        )?.ingredients?.map(i => {
          return { item_uuid: i.item_uuid, qty: i.qty, unit_uuid: i.unit_uuid }
        }) || [];

        if (unitIngredients.length && a.subaction === '0') {
          obj.unit_ingredients = unitIngredients;
        }
        arr1.push(obj);
      }
    })

    if (arr1.length) {
      const json = {
        created_at: value?.created_at,
        outlet_uuid: value?.outlet_uuid,
        transaction: [
          {
            warehouse_uuid: data.warehouse_uuid,
            items: arr1
          }
        ],
        voucher_date: data.voucher_date,
        voucher_narration: data.voucher_narration,
        voucher_remarks: data.voucher_remarks,
        voucher_type: value?.voucher_type,
        voucher_uuid: value?.voucher_uuid,
      }
      const url = `https://api.myfooddo.com/voucher/EditVoucher`;
      // const url = `http://localhost:5000/voucher/EditVoucher`;
      console.log(url, json);
      await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          console.log("EditVoucher...", data);
        })
        .catch(err => console.warn("post request failed", err));
    }
  }

  const handleSave = async (e) => {
    e.preventDefault();
    if (data.items1[0].item_uuid) {
      CreateVoucherInDB();
      EditItemsInDB();
    }
    setData(DEFAULT_VALUES);
  }

  const handleEdit = async (e) => {
    e.preventDefault();
    if (data.items1[0].item_uuid) {
      EditVoucherInDB();
      EditItemsInDB();
    }
    close();
  }

  return (
    <form className="accountGroup" action='' onSubmit={type === 'edit' ? handleEdit : handleSave}>
      <div className='inventory_header'>
        <h2>Inventory Waste Voucher </h2>
        {type === 'edit' && <XIcon className='closeicon' onClick={close} />}
      </div>

      <div className="topInputs">
        <div className="inputGroup">
          <label htmlFor="date">Date</label>
          <input
            type="date"
            value={
              new Date(data.voucher_date).getFullYear() +
              "-" +
              (
                "00" + (new Date(data.voucher_date)?.getMonth() + 1).toString()
              ).slice(-2) +
              "-" +
              ("00" + new Date(data.voucher_date)?.getDate().toString()).slice(
                -2
              )
            }
            onChange={e => {
              const nDate = new Date(e.target.value);
              setData({
                ...data,
                voucher_date: (new Date(Date.UTC(nDate?.getFullYear(), nDate?.getMonth(), nDate?.getDate(), 0, 0, 0))).getTime()
              })
            }}
            disabled={(type !== 'edit' || editValues) ? false : true}
          />
        </div>
        <div className="inputGroup">
          <label htmlFor="Warehouse">Warehouse</label>
          <select
            required
            value={data.warehouse_uuid}
            disabled={(type !== 'edit' || editValues) ? false : true}
            onChange={e => setData({
              ...data,
              warehouse_uuid: e.target.value,
            })}
          >
            <option value='' disabled>Select</option>
            {warehouses.map((a, i) =>
              <option key={i.toString()} value={a.warehouse_uuid} >{a.warehouse_title}</option>
            )}
          </select>
        </div>
      </div>

      <div className="items_table" style={{ flex: '1', paddingLeft: '10px', height: 'auto' }}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 tl bb b--black-20 w-30">Item Name</th>
              <th className="pa2 tc bb b--black-20">Quantity</th>
              <th className="pa2 tc bb b--black-20">Unit</th>
              <th className="pa2 tl bb b--black-20 w-30">Remarks</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {data.items1.map((item, i) => {
              return <tr key={i}>
                <td className="ph2 pv1 tl bb b--black-20 bg-white">
                  <div className="inputGroup">
                    {(type !== 'edit' || editValues) ?
                      <Select
                        options={items.map((item, j) => {
                          return { value: item.item_uuid, label: item.item_name, key: j }
                        })}
                        onChange={(e) => {
                          const x = data.items1.filter((a) => +a.key !== +i)
                          let y = data.items1.find((a) => +a.key === +i)
                          y.item_uuid = e.value;
                          if (!y.unit_uuid) {
                            y.unit_uuid = items?.find(a =>
                              a.item_uuid === e.value
                            )?.units?.find(b =>
                              b.unit_is_primary === 'Y'
                            )?.unit_uuid || ''
                          }
                          setData({ ...data, items1: [...x, y] })
                        }}
                        value={items.filter((a) => a.item_uuid === data.items1.find((a) => +a.key === +i).item_uuid)
                          .map((b) => ({ value: b.item_uuid, label: b.item_name })
                          )[0] || null}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder='Item'
                      />
                      : items.find(a => a.item_uuid === data.items1.find((a) => +a.key === +i).item_uuid)?.item_name || '-'}
                  </div>
                </td>
                <td className="ph2 pv1 tc bb b--black-20 bg-white">
                  {(type !== 'edit' || editValues) ?
                    <><input
                      id='Quantity'
                      type="number"
                      className='qtyInput'
                      min={1}
                      onKeyDown={event => {
                        if (event.keyCode === 38 || event.keyCode === 40) event.preventDefault();
                      }}
                      onWheel={(e) => e.preventDefault()}
                      required={data.items1.find((a) => +a.key === +i).item_uuid ? true : false}
                      value={data.items1.find((a) => +a.key === +i).qty}
                      onChange={(e) => {
                        const x = data.items1.filter((a) => +a.key !== +i);
                        let y = data.items1.find((a) => +a.key === +i);
                        y.qty = e.target.value;
                        setData({ ...data, items1: [...x, y] })
                      }}
                    /><br />
                      {data.items1.find((a) => +a.key === +i).qty
                        && data.items1.find((a) => +a.key === +i).item_uuid
                        && items?.find(a =>
                          a.item_uuid === data.items1.find((a) => +a.key === +i).item_uuid
                        )?.ingredients?.length
                        ? (<select
                          disabled={(type !== 'edit' || editValues) ? false : true}
                          value={data.items1.find((a) => +a.key === +i)?.subaction}
                          onChange={(e) => {
                            const x = data.items1.filter((a) => +a.key !== +i)
                            let y = data.items1.find((a) => +a.key === +i)
                            y.subaction = e.target.value;
                            setData({ ...data, items1: [...x, y] })
                          }}
                        >
                          <option value="0">Ingredients</option>
                          <option value="1">Main Item</option>
                        </select>
                        ) : ''}
                    </>
                    : (data.items1.find((a) => +a.key === +i).qty || '-')}
                </td>
                <td className="ph2 pv1 tc bb b--black-20 bg-white">
                  {(type !== 'edit' || editValues) ?
                    <select
                      id='Unit'
                      required={data.items1.find((a) => +a.key === +i).item_uuid ? true : false}
                      value={data.items1.find((a) => +a.key === +i).unit_uuid}
                      onChange={(e) => {
                        const x = data.items1.filter((a) => +a.key !== +i);
                        let y = data.items1.find((a) => +a.key === +i);
                        y.unit_uuid = e.target.value;
                        setData({ ...data, items1: [...x, y] })
                      }}
                    > <option key={0} value='' disabled>Select Unit</option>
                      {items?.find(a =>
                        a.item_uuid === data.items1.find((a) => +a.key === +i).item_uuid
                      )?.units?.map(a =>
                        <option key={a.unit_uuid} value={a.unit_uuid}>{a.unit_name}</option>
                      )}
                    </select>
                    : items?.find(a =>
                      a.item_uuid === data.items1.find((a) => +a.key === +i).item_uuid
                    )?.units?.find(a =>
                      a.unit_uuid === data.items1.find((a) => +a.key === +i).unit_uuid
                    )?.unit_name || '-'
                  }
                </td>
                <td className="ph2 pv1 tl bb b--black-20 bg-white">
                  <div className="inputGroup">
                    {(type !== 'edit' || editValues) ?
                      <input
                        type="text"
                        maxLength="200"
                        required={data.items1.find((a) => +a.key === +i).item_uuid ? true : false}
                        value={data.items1.find((a) => +a.key === +i).remarks}
                        onChange={(e) => {
                          const x = data.items1.filter((a) => +a.key !== +i)
                          let y = data.items1.find((a) => +a.key === +i)
                          y.remarks = e.target.value;
                          setData({ ...data, items1: [...x, y] })
                        }}
                        placeholder="Remarks..."
                      />
                      : data.items1.find((a) => +a.key === +i).remarks || '-'}
                  </div>
                </td>
              </tr>
            })}
            <tr>
              <td onClick={addNewRow}>
                <AddIcon sx={{ fontSize: 40 }} style={{ color: '#4AC959', cursor: 'pointer' }} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="topInputs">
        <textarea
          placeholder="Narration (Displayed)...."
          disabled={(type !== 'edit' || editValues) ? false : true}
          maxLength="200"
          value={data.voucher_narration}
          onChange={e => setData({
            ...data,
            voucher_narration: e.target.value,
          })}
        ></textarea>
        <textarea
          placeholder="Remarks (Not Displayed)...."
          disabled={(type !== 'edit' || editValues) ? false : true}
          maxLength="200"
          value={data.voucher_remarks}
          onChange={e => setData({
            ...data,
            voucher_remarks: e.target.value,
          })}
        ></textarea>
      </div>

      <div className="bottomContent">
        {
          type === 'edit' && !editValues ?
            <button
              onClick={(e) => {
                e.preventDefault();
                setEditValues(true);
                return false;
              }}
            >
              Edit
            </button>
            : <button type='submit'>Save</button>
        }
      </div>
    </form>
  )
}